import React from 'react'
import { ArchivoComponent } from './ArchivoComponent'

const ArchivosMarcaComponent = (props) => {
  
    const {tabla, id, api, idAnexoFK = undefined, filesMap = undefined} = props
    const {handdleFile, handdleRemovePrev, files} = api
    const marca = props.marca
    const [opcionTipoArchivoMarca, setOpcionTipoArchivoMarca] = React.useState("")
    
    return (
        <div>
            <label className='label-blanco'>Marca: {marca.marca}</label>
            <br/>
            <hr/>
            {
                marca.registrosi ? (
                    marca.idtitularidaddemarca === 1 ? 
                        <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULO${id}`} tabla={tabla}  textLabel="Título de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/> 
                    : 
                    marca.idtitularidaddemarca === 2 ? 
                        <>
                        </>
                    :
                    marca.idtitularidaddemarca === 3 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULO${id}`} tabla={tabla}  textLabel="Título de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`LICAUT${id}`} tabla={tabla}  textLabel="Licencia de uso autorizada" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                    marca.idtitularidaddemarca === 4 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULO${id}`} tabla={tabla}  textLabel="Título de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CESAUT${id}`} tabla={tabla}  textLabel="Cesión de derechos de marca autorizada" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                    marca.idtitularidaddemarca === 5 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULO${id}`} tabla={tabla}  textLabel="Título de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`LICT${id}`} tabla={tabla}  textLabel="Licencia de uso en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CRLT${id}`} tabla={tabla}  textLabel="Carta responsiva de licencia de uso en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                    marca.idtitularidaddemarca === 6 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULO${id}`} tabla={tabla}  textLabel="Título de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CESMT${id}`} tabla={tabla}  textLabel="Cesión de derechos de marca en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap} />
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CRCDMT${id}`} tabla={tabla}  textLabel="Carta responsiva de cesión de derechos de marca en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                ('')) : (
                    marca.idtitularidaddemarca === 1 ? 
                        <>
                            
                        </>
                        
                    : 
                    marca.idtitularidaddemarca === 2 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CM${id}`} tabla={tabla}  textLabel="Comprobante de marca en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap} />
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CRMT${id}`} tabla={tabla}  textLabel="Carta responsiva por la marca en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                    marca.idtitularidaddemarca === 3 ? 
                        <>
                            
                        </>
                    :
                    marca.idtitularidaddemarca === 4 ? 
                        <>
                            
                        </>
                    :
                    marca.idtitularidaddemarca === 5 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CM${id}`} tabla={tabla}   textLabel="Comprobante en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`LICT${id}`} tabla={tabla}  textLabel="Licencia de uso en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CRMLT${id}`} tabla={tabla}  textLabel="Carta responsiva y licencia de uso en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                    marca.idtitularidaddemarca === 6 ? 
                        <>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CM${id}`} tabla={tabla}  textLabel="Comprobante en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CEST${id}`} tabla={tabla}  textLabel="Comprobante de cesión de derechos en trámite" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CRMCT${id}`} tabla={tabla}  textLabel="Carta responsiva y cesión de derechos en trámite " idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                        </>
                    :
                (''))
            }
            <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`JE${id}`} tabla={tabla} textLabel="Juego de etiquetas de la marca" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
        </div>
    )
}

export default ArchivosMarcaComponent